import React, { useContext } from "react";
import { FilterContext } from "../../../context/FilterContext";
import { ColorModeContext } from "../../../context/ColorModeContext";
import { ReactComponent as IconX } from "../../../assets/x.svg";
import classes from "./FilterTags.module.css";

const FilterTags = () => {
  const { filter, deleteColor, deleteCategory, deleteEmbroideryFormat, deleteInputSearchVal } =
    useContext(FilterContext);

  const { isDarkMode } = useContext(ColorModeContext);

  return (
    <>
      {filter.name && (
        <p
          className={`${classes.searchName} ${
            isDarkMode ? classes.darkMode : ""
          }`}
        >
          <button onClick={deleteInputSearchVal} title="excluir pesquisa">
            <IconX />
          </button>{" "}
          Resultados para "{filter.name}"
        </p>
      )}
      {(filter.colors.length !== 0 || filter.categories.length !== 0 || filter.embroideryformats.length !== 0) && (
        <ul className={classes.filterList}>
          {filter.colors.map((color) => (
            <li key={color}>
              {color}{" "}
              <button
                title={`Excluir filtro para a cor: ${color}`}
                onClick={() => deleteColor(color)}
              >
                <IconX />
              </button>
            </li>
          ))}
          {filter.categories.map((category) => (
            <li key={category}>
              {category}{" "}
              <button
                title={`Excluir filtro da categoria: ${category}`}
                onClick={() => deleteCategory(category)}
              >
                <IconX />
              </button>
            </li>
          ))}
          {filter.embroideryformats.map((embroideryformat) => (
            <li key={embroideryformat}>
              {embroideryformat}{" "}
              <button
                title={`Excluir filtro do formato de arquivo: ${embroideryformat}`}
                onClick={() => deleteEmbroideryFormat(embroideryformat)}
              >
                <IconX />
              </button>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default FilterTags;
